/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { isEmpty } from '@ember/utils';

interface SendToUnsubscribedAlertArgs {
  campaign: CampaignModel;
}

export default class SendToUnsubscribedAlert extends Component<SendToUnsubscribedAlertArgs> {
  get maySendToUnsubscribed() {
    return !isEmpty(this.args.campaign.workflowActions.filter((action) => action.sendToUnsubscribed));
  }
}
